import {isValueNotEmptyString} from '../../../../../../../utils/validators'
import {
  DOCKER_IMAGE_PROPERTY_NAME,
  DOCKERFILE_PATH_PROPERTY_NAME,
  DOCKERFILE_SOURCE_PROPERTY_NAME,
} from '../../JobStepRunInDocker/JobStepRunInDocker.consts'

const cliErrorValidators = [
  {
    validator: isValueNotEmptyString,
    message: 'Script content should not be empty',
  },
]

const dockerImageErrorValidators = [
  {
    validator: isValueNotEmptyString,
    message: 'Docker image name should not be empty',
  },
]

const dockerfileSourceErrorValidators = [
  {
    validator: isValueNotEmptyString,
    message: 'Dockerfile content should not be empty',
  },
]
const dockerfilePathErrorValidators = [
  {
    validator: isValueNotEmptyString,
    message: 'Dockerfile path should not be empty',
  },
]

export const errorValidators = {
  'script-content': cliErrorValidators,
  [DOCKER_IMAGE_PROPERTY_NAME]: dockerImageErrorValidators,
  [DOCKERFILE_SOURCE_PROPERTY_NAME]: dockerfileSourceErrorValidators,
  [DOCKERFILE_PATH_PROPERTY_NAME]: dockerfilePathErrorValidators,
}
